import { render, staticRenderFns } from "./BusinessNameMessagesEscalated.vue?vue&type=template&id=d1dfa440&scoped=true&"
import script from "./BusinessNameMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./BusinessNameMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dfa440",
  null
  
)

export default component.exports